'use client'

import GenericForm from 'components/Form'
import { AuthPasswordRecovery } from 'api/auth'
import { object, string } from 'yup'

interface ResetPasswordText {
    pleaseEnterYourEmail: string
    emailAddress: string
    sendRequestPasswordLink: string
}

interface UserPasswordResetFormProps {
    t: ResetPasswordText
    domainName: string
}

const resetPasswordSchema = object({
    email: string()
        .required('Please enter your email')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Enter a valid email')
})

const ResetPasswordForm = ({ t, domainName }: UserPasswordResetFormProps) => {
    const fields: TFormField[] = [
        {
            name: 'email',
            label: t.emailAddress,
            type: 'email',
            required: true,
            placeholder: t.pleaseEnterYourEmail
        }
    ]

    const onSubmit = async (formData: FormData): Promise<ApiResponse> => {
        const email = formData.get('email')?.toString()
        if (!email) return { success: false, message: 'Missing email' }
        return await AuthPasswordRecovery({ email }, domainName)
    }

    return (
        <GenericForm
            fields={fields}
            onSubmit={onSubmit}
            buttonTexts={{ save: t.sendRequestPasswordLink, saving: '' }}
            validationSchema={resetPasswordSchema}
        />
    )
}

export default ResetPasswordForm
